module.exports = __webpack_public_path__ + "media/images/countrysquared/bo-1219383c4697aec0118e46cc427f1545.svg";